module.exports = __webpack_public_path__ + "media/theme/sample__recochoku--sp-af0b39c9.png";